/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';
import type { Upload } from './Upload';
import {
    UploadFromJSON,
    UploadFromJSONTyped,
    UploadToJSON,
    UploadToJSONTyped,
} from './Upload';

/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    name: string;
    /**
     * Whether the document should be visible to all employees
     * @type {boolean}
     * @memberof Document
     */
    visibleToAll: boolean;
    /**
     * Any specific employees who should be able to view this document
     * @type {Array<number>}
     * @memberof Document
     */
    employeeIds: Array<number>;
    /**
     * Any employees with these job roles should be able to view this document
     * @type {Array<number>}
     * @memberof Document
     */
    jobRoleIds: Array<number>;
    /**
     * The id of the latest version of this document
     * @type {number}
     * @memberof Document
     */
    latestVersionId: number;
    /**
     * The ID of the employee who uploaded the latest version of this document
     * @type {number}
     * @memberof Document
     */
    uploaderId: number | null;
    /**
     * Indicates whether the document must be read by employees, and if so, by when
     * @type {Date}
     * @memberof Document
     */
    readDeadline: Date | null;
    /**
     * The date when the document expires
     * @type {ShiftiePlainDate}
     * @memberof Document
     */
    expiryDate: ShiftiePlainDate | null;
    /**
     * The number of employees who have marked the current version of this document as 'read'.
     * @type {number}
     * @memberof Document
     */
    readCount: number;
    /**
     * 
     * @type {Date}
     * @memberof Document
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Document
     */
    updatedAt: Date | null;
    /**
     * 
     * @type {Upload}
     * @memberof Document
     */
    upload: Upload;
    /**
     * Indicates whether the document must be accepted by employees
     * @type {boolean}
     * @memberof Document
     */
    acceptanceRequired: boolean;
}

/**
 * Check if a given object implements the Document interface.
 */
export function instanceOfDocument(value: object): value is Document {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('visibleToAll' in value) || value['visibleToAll'] === undefined) return false;
    if (!('employeeIds' in value) || value['employeeIds'] === undefined) return false;
    if (!('jobRoleIds' in value) || value['jobRoleIds'] === undefined) return false;
    if (!('latestVersionId' in value) || value['latestVersionId'] === undefined) return false;
    if (!('uploaderId' in value) || value['uploaderId'] === undefined) return false;
    if (!('readDeadline' in value) || value['readDeadline'] === undefined) return false;
    if (!('expiryDate' in value) || value['expiryDate'] === undefined) return false;
    if (!('readCount' in value) || value['readCount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('upload' in value) || value['upload'] === undefined) return false;
    if (!('acceptanceRequired' in value) || value['acceptanceRequired'] === undefined) return false;
    return true;
}

export function DocumentFromJSON(json: any): Document {
    return DocumentFromJSONTyped(json, false);
}

export function DocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Document {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'name': json['name'],
        'visibleToAll': json['visibleToAll'],
        'employeeIds': json['employeeIds'],
        'jobRoleIds': json['jobRoleIds'],
        'latestVersionId': json['latestVersionId'],
        'uploaderId': json['uploaderId'],
        'readDeadline': (json['readDeadline'] == null ? null : new Date(json['readDeadline'])),
        'expiryDate': ShiftiePlainDateFromJSON(json['expiryDate']),
        'readCount': json['readCount'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
        'upload': UploadFromJSON(json['upload']),
        'acceptanceRequired': json['acceptanceRequired'],
    };
}

  export function DocumentToJSON(json: any): Document {
      return DocumentToJSONTyped(json, false);
  }

  export function DocumentToJSONTyped(value?: Document | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'name': value['name'],
        'visibleToAll': value['visibleToAll'],
        'employeeIds': value['employeeIds'],
        'jobRoleIds': value['jobRoleIds'],
        'latestVersionId': value['latestVersionId'],
        'uploaderId': value['uploaderId'],
        'readDeadline': (value['readDeadline'] == null ? null : (value['readDeadline'] as any).toISOString()),
        'expiryDate': ShiftiePlainDateToJSON(value['expiryDate']),
        'readCount': value['readCount'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': (value['updatedAt'] == null ? null : (value['updatedAt'] as any).toISOString()),
        'upload': UploadToJSON(value['upload']),
        'acceptanceRequired': value['acceptanceRequired'],
    };
}

